import { Injectable } from "@angular/core";
import { ToastService } from "ng-uikit-pro-standard";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  // constructor(private notification: ToastService) {}

  // showMessageSucess(message: any) {
  //   return this.notification.success(message);
  // }

  // showError(message: any) {
  //   return this.notification.error(message);
  // }

  // showMessageWarning(message: any) {
  //   return this.notification.warning(message);
  // }

  // showInfoNotification(message: any) {
  //   return this.notification.info(message);
  // }
}
